import { z } from "zod";
export var TransportKind = /*#__PURE__*/ function(TransportKind) {
    TransportKind["WebKitPostMessage"] = "webkit_post_message";
    TransportKind["EditorIframe"] = "editor";
    TransportKind["Android"] = "android";
    return TransportKind;
}({});
export var Platform = /*#__PURE__*/ function(Platform) {
    Platform["iOS"] = "ios";
    Platform["Android"] = "android";
    Platform["MacOS"] = "macos";
    Platform["UIKitForMac"] = "uikitformac";
    return Platform;
}({});
export const InitializationParamsSchema = z.object({
    sdkVersion: z.string().optional(),
    transport: z.nativeEnum(TransportKind).default("webkit_post_message"),
    platform: z.nativeEnum(Platform).default("ios"),
    enableEditorHover: z.string().optional().transform((z)=>z === "true" ? true : false)
});
export const ParameterNames = Object.keys(InitializationParamsSchema.shape);
